import transactionResource from "@/http/TransactionResource";

export default {
  namespaced: true,
  state: {
    transactions: null,
    pagination: null,
  },
  getters: {
    getTransactions(state) {
      return state.transactions;
    },
    getPagination(state) {
      return state.pagination;
    },
  },
  mutations: {
    setTransactions(state, payload) {
      state.transactions = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },
  actions: {
    transactions({commit}, params) {
      return transactionResource.transactions(params)
        .then(response => {
          commit('setTransactions', response.data?.data);
          commit('setPagination', response.data?.meta);
          return Promise.resolve(response);
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
  },
}
